import { colors, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      height: "100%",
      background: colors.common.white,
    },
    navBarSlideWrapper: {
      position: "absolute",
      height: "calc(100vh - 102px)",
      left: 0,
      top: 50,
      zIndex: 2000,
      width: 500,
      overflow: "hide",
      background: theme.palette.common.white,
    },
    activeTab: {
      color: "blue",
    },

    confirmed: {
      color: "green",
    },

    unconfirmed: {
      color: "red",
    },

    tabsPanel: {
      width: "100%",
      height: "calc(100vh - 101px)",
      overflowX: "hidden",
      overflowY: "auto",
    },

    wrapperHeader: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      borderBottom: "1px solid #e8e8e8",

      "& .subMainTitle": {
        fontSize: 14,
      },
      "& .mainTitle": {},
    },

    loader: {
      marginTop: 8,
    },

    error: {
      fontSize: 14,
      color: colors.red[700],
      textAlign: "left",
    },

    settingsWrapper: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      textAlign: "center",

      "& .mainTitle": {
        fontSize: 20,
        width: "100%",
        textAlign: "center",
        fontWeight: "bold",
      },

      "& .settingWrapper": {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        // border: "1px solid red",

        "& .title": {
          fontSize: 14,
          fontWeight: theme.typography.fontWeightBold,
        },

        "& .settingWrapperInner": {
          // border: "1px solid red",
        },
      },
    },
  }),
  {
    name: "raffle-draw-tab-panel-styles",
    flip: null,
  }
);

export default useStyles;
